var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#007AFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6883 43.312C19.1602 41.836 17.9412 40.0705 17.1027 38.1185C16.2642 36.1664 15.8228 34.0669 15.8043 31.9424C15.7859 29.8179 16.1907 27.7111 16.9952 25.7447C17.7997 23.7784 18.9877 21.992 20.49 20.4897C21.9923 18.9874 23.7787 17.7993 25.7451 16.9948C27.7114 16.1903 29.8183 15.7855 31.9427 15.804C34.0672 15.8224 36.1667 16.2638 38.1188 17.1024C40.0709 17.9409 41.8364 19.1598 43.3123 20.688C46.2269 23.7056 47.8396 27.7473 47.8031 31.9424C47.7667 36.1376 46.084 40.1506 43.1174 43.1171C40.1509 46.0836 36.1379 47.7663 31.9427 47.8028C27.7476 47.8392 23.706 46.2265 20.6883 43.312ZM41.0563 41.056C43.4581 38.6542 44.8074 35.3966 44.8074 32C44.8074 28.6033 43.4581 25.3458 41.0563 22.944C38.6545 20.5422 35.397 19.1929 32.0003 19.1929C28.6037 19.1929 25.3461 20.5422 22.9443 22.944C20.5425 25.3458 19.1932 28.6033 19.1932 32C19.1932 35.3966 20.5425 38.6542 22.9443 41.056C25.3461 43.4578 28.6037 44.8071 32.0003 44.8071C35.397 44.8071 38.6545 43.4578 41.0563 41.056ZM30.4003 33.6V30.4H33.6003V40H30.4003V33.6ZM30.4003 24H33.6003V27.2H30.4003V24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.14c67dc42de791ce924b6ddaf51c3613.svg";
export { ForwardRef as ReactComponent };